import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const SkeletonLoader = () => {
  return (
    <div className="skeleton-loader m-5">
      <Skeleton height={60} width={450} borderRadius={20} className="mb-10" />
      <Skeleton height={150} width={1100} borderRadius={25} className="mb-16" />
      <Skeleton height={45} width={350} borderRadius={20} className="mb-10" />
      <Skeleton height={133} width={1100} borderRadius={25} className="mb-16" />
      <Skeleton height={50} width={350} borderRadius={20} className="mb-5" />
    </div>
  );
};

export default SkeletonLoader;
